var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckFriend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.531 7.28055L9.53104 19.2806C9.46139 19.3503 9.37867 19.4056 9.28762 19.4433C9.19657 19.4811 9.09898 19.5005 9.00042 19.5005C8.90186 19.5005 8.80426 19.4811 8.71321 19.4433C8.62216 19.4056 8.53945 19.3503 8.46979 19.2806L3.21979 14.0306C3.07906 13.8898 3 13.699 3 13.4999C3 13.3009 3.07906 13.11 3.21979 12.9693C3.36052 12.8286 3.55139 12.7495 3.75042 12.7495C3.94944 12.7495 4.14031 12.8286 4.28104 12.9693L9.00042 17.6896L20.4698 6.2193C20.6105 6.07857 20.8014 5.99951 21.0004 5.99951C21.1994 5.99951 21.3903 6.07857 21.531 6.2193C21.6718 6.36003 21.7508 6.55091 21.7508 6.74993C21.7508 6.94895 21.6718 7.13982 21.531 7.28055Z",
    fill: "#00BA6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFriend);
export default __webpack_public_path__ + "static/media/CheckFriend.076595d1e8cb0493bbc54ed9ed09024f.svg";
export { ForwardRef as ReactComponent };